import { actions as viewActions } from '../modules/view';

const debounceTime = 100;
let runningActions = 0;
let timer;
let intervalId;

export default function loadingAnimationMiddleware({ dispatch }) {
	return next => (action) => {
		if (!action.hasOwnProperty('data') ||
			!action.data.hasOwnProperty('isPolling') ||
			!action.data.isPolling) {
			if (/_PENDING$/.test(action.type)) {
				if (runningActions <= 0) {
					intervalId = setTimeout(() => {
						timer = Date.now();
						dispatch(viewActions.toggleLoadingAnimation(true));
					}, debounceTime);
				}
				runningActions++;
			} else if (/_(FAILURE|SUCCESS)$/.test(action.type)) {
				runningActions--;

				if (runningActions <= 0) {
					const now = Date.now() - timer;
					clearTimeout(intervalId);
					setTimeout(() => {
						dispatch(viewActions.toggleLoadingAnimation(false));
					}, 1440 - (now % 1400));
				}
			}
		}

		return next(action);
	};
}



// WEBPACK FOOTER //
// ./src/redux/middleware/loading-animation-middleware.js